import React from 'react'
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import Icon from '../../../../../ui/Icon/Icon'
import BrandListItem from './BrandListItem'
import styles from './BrandsPanel.module.scss'

const DragHandle = SortableHandle(({ name, disabled }) => (
  <button
    type="button"
    className={styles.dragHandle}
    aria-label={`Змінити порядок: ${name}`}
    title="Перетягніть або натисніть пробіл і використовуйте стрілки"
    disabled={disabled}
    onClick={(event) => event.stopPropagation()}
  >
    <Icon name="bars" weight="solid" size={11} />
  </button>
))

const SortableBrand = SortableElement(({ brand, isSaving, ...props }) => (
  <BrandListItem {...props} brand={brand} dragHandle={<DragHandle name={brand.name} disabled={isSaving} />} />
))

export default SortableContainer(({ brands, isSaving, ...props }) => (
  <div className={styles.list}>
    {brands.map((brand, index) => (
      <SortableBrand key={brand.id} index={index} disabled={isSaving} brand={brand} isSaving={isSaving} {...props} />
    ))}
  </div>
))
